module.exports = __webpack_public_path__ + "img/GD.f5a5772c.png";